import React from 'react';
import Image from 'next/image';
import salesforce from './assets/salesforce.svg';
import hubspot from './assets/hubspot.svg';
import dynamics from './assets/dynamics.svg';
import pipedrive from './assets/pipedrive.svg';
import zoho_allblue from './assets/zoho_allblue.svg';
import medrm from './assets/medrm.svg';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

interface BrandIconProps {
  brand: string;
  height?: string;
  width?: string;
  invert?: boolean;
  neutral?: boolean;
}

const BrandIcon = ({
  brand,
  height,
  width,
  invert,
  neutral = false,
}: BrandIconProps) => {
  const isThirdParty = brand?.toLowerCase() === 'third_party';
  const iconType = {
    salesforce: salesforce,
    hubspot: hubspot,
    microsoftdynamics: dynamics,
    zohocrm: zoho_allblue,
    pipedrive: pipedrive,
    medrm: medrm,
  };

  return isThirdParty ? (
    <Icon
      icon={faArrowRightArrowLeft}
      color={neutral ? '#525252' : invert ? 'white' : '#133D80'}
      style={{
        width: width || '2rem',
        height: height || '1.8rem',
      }}
      aria-label={`${brand} icon`}
    />
  ) : brand && iconType[brand] ? (
    <Image
      src={iconType[brand]}
      alt={`${brand} icon`}
      style={{
        width: width || '1.6rem',
        height: height || '1.6rem',
        filter: neutral
          ? 'brightness(0) saturate(100%) invert(32%) sepia(0%) saturate(0%) hue-rotate(143deg) brightness(92%) contrast(85%)'
          : //this sets the icon to a neutral gray color
          invert
          ? 'brightness(0) invert(1)'
          : 'none',
      }}
      aria-label={`${brand} icon`}
    />
  ) : null;
};

export default BrandIcon;
